import o from "./_root.js";
var t = function() {
  return o.Date.now();
};
const r = t;
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/now.js
// module id = 1526
// module chunks = 41